<template>
    <div class="newbooking">
        <Booking></Booking>
    </div>
</template>

<style scoped>
    .newbooking{
        background : #F5F7FA;
    }
</style>


<script>
    import Booking from '@/components/newbooking_component.vue';
    export default {
        name: 'newbooking',
        data() {
            return {
                //'check': this.Constants.STATUS_CONFIRMED
            }
        },
        components: {
            Booking
        }
    }
</script>
